import React from 'react';
import { IconProps } from '.';

const SvgTShirtFillRounded = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M15.998 3.402c1.004.065 1.858.337 3 1.48 1.398 1.398 2.407 4.86 2.853 6.997a.967.967 0 0 1-.573 1.08l-2.28.99v-2.567a.5.5 0 0 0-1 0v8a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-8a.5.5 0 0 0-1 0v2.566l-2.28-.988a.967.967 0 0 1-.573-1.081c.446-2.137 1.456-5.6 2.854-6.997 1.142-1.143 1.995-1.415 3-1.48.55-.035.971.456 1.238.94.457.83 1.522 1.29 2.761 1.29 1.24 0 2.304-.46 2.761-1.29.267-.484.688-.975 1.239-.94Zm-6 6.23v1.5h4v-1.5h-4Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgTShirtFillRounded;
